"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { TwitterRoutedPage } from './deskUi/TwitterRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function TwitterSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={TwitterRoutedPage} Loading={MsgDeskLoading} />
}
